/* eslint-disable @typescript-eslint/no-explicit-any */

import { breakpoints } from "@brightagency/headstart-common";
import React, { CSSProperties } from "react";
import styled, { css } from "styled-components";

interface GridBreakpoint {
    breakpointWidth: number;
    columns: number;
    gutter: number;
    childPercentages?: Array<string>;
}

export type GridBreakpoints = GridBreakpoint[];

export const Wrapper = styled.div<{
    breakpoints: GridBreakpoints;
    alignItems?: string;
}>`
    display: flex;
    flex-wrap: wrap;

    ${props =>
        props.alignItems &&
        css`
            align-items: ${props.alignItems};
        `}

    ${props =>
        props.breakpoints.map(
            breakpoint =>
                css`
                    ${breakpoints.custom(breakpoint.breakpointWidth)} {
                        margin: ${breakpoint.gutter / -2}px;
                    }
                `,
        )}
`;

export const Child = styled.div<{ breakpoints: GridBreakpoints }>`
    ${props =>
        props.breakpoints.map(breakpoint => {
            if (breakpoint.childPercentages) {
                return css`
                    ${breakpoints.custom(breakpoint.breakpointWidth)} {
                        ${() =>
                            (breakpoint.childPercentages || []).map(
                                (childWidth, index) => css`
                                    &:nth-child(${index + 1}) {
                                        flex-basis: ${childWidth};
                                        padding: ${breakpoint.gutter / 2}px;
                                    }
                                `,
                            )}
                    }
                `;
            }
            return css`
                ${breakpoints.custom(breakpoint.breakpointWidth)} {
                    flex-basis: ${(12 / breakpoint.columns / 12) * 100}%;
                    padding: ${breakpoint.gutter / 2}px;
                }
            `;
        })}
`;

interface GridProps {
    breakpoints: GridBreakpoints;
    alignItems?: string;
    flexDirection?: "row" | "row-reverse";
    style?: CSSProperties;
    className?: string;
}

export const Grid: React.FC<GridProps> = props => {
    return (
        <Wrapper
            className={props.className}
            breakpoints={props.breakpoints}
            alignItems={props.alignItems}
            style={{
                ...props.style,
                flexDirection: props.flexDirection,
            }}
        >
            {React.Children.map(props.children, child => (
                <Child breakpoints={props.breakpoints}>{child}</Child>
            ))}
        </Wrapper>
    );
};

Grid.defaultProps = {
    breakpoints: [
        {
            breakpointWidth: 0,
            columns: 4,
            gutter: 30,
        },
    ],
};
